/**
  * WBT-Data Model
  * @namespace v3sWbtPlayerApp:model
  */

/**
 * WBT-Data-Root, referenziert alle SCOs als Liste und als Baum
 * @class service_v3sWbt
 * @memberOf v3sWbtPlayerApp:model
 * @extends v3sWbtPlayerApp:model.service_v3sSco
 */
angular.module('v3sWbtPlayerApp').factory('v3sWbt', ["v3sSco", "v3sStructureSco", "v3sTestSco", function (v3sSco, v3sStructureSco, v3sTestSco) {

    var testSco = null;

    // instantiate the sco object
    var v3sWbt = function (data) {
        this.description = "";
        this.version = "";

        // use the original sco object constructor
        v3sSco.apply(this, arguments);

        // Kinder sollen die Werte selbst schreiben
        this.childrenIncludeFilter = [this.ScormDataEnum.STATUS, this.ScormDataEnum.SCORE];

        if (!!data) {
            createStructure(data.children, this); //wbt structure (list & tree)
        }

        this.updateTreeDepth();
        this.updateExercisesCount();
    };

    // use the original v3sItem prototype
    v3sWbt.prototype = new v3sSco();

    function createStructure(children, parent, treeParent) {
        if (!!children && children.length > 0) {
            var scos = [];
            for (var i = 0; i < children.length; i++) {
                var item = children[i];
                var sco;

                if (item.type === "standardSco") {
                    if (!!item.parameters && item.parameters.indexOf("type") != -1) {
                        sco = new v3sTestSco(item);
                        testSco = sco;
                    } else {
                        sco = new v3sSco(item);
                    }
                } else if (item.type === "structureSco") {
                    sco = new v3sStructureSco(item);
                }

                if (!!sco) {
                    sco.parent = parent;
                    if (!!treeParent) {
                        sco.treeParent = treeParent;
                    }
                    scos.push(sco);
                    parent.children.push(sco);

                    if (item.type === "structureSco") {
                        sco.setTreeChildren(createStructure(item.children, parent, sco));
                    }
                }
            }
            return scos;
        }
    }

    v3sWbt.prototype.getChildrenForUpdate = function () {
        var childrenForUpdate = [];

        angular.forEach(this.getChildren(), function (item) {
            if (item.isTrackable() && !(item instanceof v3sStructureSco)) {
                childrenForUpdate.push(item);
            }
        });

        return childrenForUpdate;
    };


    v3sWbt.prototype.getExerciseStatistic = function () {
        var statisticData = { count: 0, correct: 0, wrong: 0, score: 0 };

        angular.forEach(this.getChildren(), function (child) {
            if (!(child instanceof v3sStructureSco)) {
                var childStatistic = child.getExerciseStatistic();
                statisticData.count += childStatistic.count;
                statisticData.correct += childStatistic.correct;
                statisticData.wrong += childStatistic.wrong;
            }
        });

        statisticData.score = Math.round(statisticData.correct / statisticData.count * 100);

        return statisticData;
    };

    v3sWbt.prototype.getTestSco = function () {
        return testSco;
    };

    v3sWbt.prototype.getFirstChild = function () {
        var nextChild = null;
        if (!!this.children) {
            var i = 0;
            nextChild = this.children[i];
            while (!nextChild.isVisible() && !!this.children[i+1]) {
                i++
                nextChild = this.children[i];
            }
        }
        return nextChild;
    }

    v3sWbt.prototype.getLastChild = function () {
        var nextChild = null;
        if (!!this.children) {
            var i = this.children.length -1;
            nextChild = this.children[i];
            while (nextChild.visible === false && !!this.children[i-1]) {
                i--
                nextChild = this.children[i];
            }
        }
        return nextChild;
    }

    v3sWbt.prototype.getChildren = function () {
        return this.children;
    };

    v3sWbt.prototype.getExerciseStatus = function () {
        var status = "";

        for (var i = 0; i < this.children.length ; i++) {
            if (this.children[i].getType() !== "structureSco") {
            var itemStatus = this.children[i].getExerciseStatus();
            if (itemStatus == "passed") {
                status = itemStatus;
            } else if (itemStatus == "failed") {
                return itemStatus;
            }
        }
        }

        return status;
    };

    v3sWbt.prototype.getProgress = function (withoutTreeChildren) {
        return v3sSco.prototype.getProgress.call(this, true);
    };

    v3sWbt.prototype.getGlobalScormData = function () {
        var data = {};
        v3sSco.prototype.getGlobalScormData.call(this, data);
        return data;
    };

    return v3sWbt;
}]);